<template>
  <div id="app" class="site-shell">
    <header class="site-header">
      <div class="brand">
        <span class="brand-cn">FUN GRAFFITI STREET HATS LLC</span>
        <span class="brand-en">Registered in the United States of America · Reg. No. 41-3903563</span>
      </div>
      <nav class="site-nav">
        <router-link to="/" exact>Home</router-link>
        <router-link to="/about">About Us</router-link>
      </nav>
    </header>
    <main class="site-main" :class="{ 'is-flush': $route.name === 'home' }">
      <router-view />
    </main>
    <footer class="site-footer">
      <div class="footer-info">
        <span class="footer-name">© 2026 FUN GRAFFITI STREET HATS LLC. All rights reserved.</span>
        <span class="footer-meta">Registration No.: 41-3903563</span>
        <span class="footer-meta">Registered Address: 2800 E 12TH ST LOS ANGELES, CA 90023</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
